import React from 'react';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import AppColors from '../assets/colors';
import { inject, observer } from "mobx-react";
import Box from '@mui/material/Box';

// Translations
import _useTranslate from '../hooks/_useTranslate';

const style = {
  position: 'absolute',
   width: {
    xs: '100%',
    sm: '80%',
    md: 400,
  },
  //Its own height (it was a fixed 6150px: centred on a desktop screen, the message and buttons sat far above it).
  height: 'auto',
  p: 2,
  top: {xs: 60, sm: '50%'},
  left: {xs: 0, sm: '50%'},
  transform: {sm: 'translate(-50%, -50%)'},
  bgcolor: 'background.paper',
  border: '2px solid var(--border-color)',
  borderRadius: 4,
  boxShadow: 24
};

const Divider = () => <h3 style={{color: AppColors.secondary, marginTop: 10}}>|</h3>;

/* What went wrong with the code, and what can be done about it:
     retry   - close this and type the code again (a wrong digit, or "wait a minute before a new code")
     resend  - ask the server for a new code (expired, used up, or wrong)
     exit    - give up on this registration
   Clicking outside only closes this when there is something left to try; otherwise it is exit.
   It used to offer only resend or exit, so a mistyped digit cost the whole registration. */
const VerificationErrorModal = ({visible, message, retry, resend, exit, feathersStore})=> {

  let common = _useTranslate(feathersStore.language, "common");

  return (
    <section>
      <Modal
        open={visible}
        onClose={retry || resend ? (retry || (() => {})) : exit}
        aria-labelledby="login-modal"
        aria-describedby="login-or-register"
      >
      <Box sx={style}>
        <div className="modalContainer">
          <div className="modalTitleContainer">
            <p style={{color: AppColors.secondary}}>{message || common.errorCode}</p>
          </div>
          <div className="confirmationModalButtonsView">
            {retry && <>
              <Button
                aria-labelledby='Try again'
                style={{color: AppColors.amazonColor, fontSize: 18}}
                onClick={retry}
              >{(common.tryAgain || "Try again").toUpperCase()}</Button>
              <Divider/>
            </>}
            {resend && <>
              <Button
                aria-labelledby='Resend'
                style={{color: AppColors.amazonColor, fontSize: 18}}
                onClick={resend}
              >{common.repeat}</Button>
              <Divider/>
            </>}
            <Button
              aria-labelledby='Exit'
              style={{color: AppColors.red, fontSize: 18}}
              onClick={exit}
            >{common.exit}</Button>
          </div>
        </div>
      </Box>
      </Modal>
    </section>
  );
}

export default inject('feathersStore')(observer(VerificationErrorModal));
